/**
 * useDocumentTitle — Sets the browser document title reactively.
 */
import { useEffect } from "react";

const SITE_NAME = "Goaldigger";

/**
 * Sets document.title on mount and restores it on unmount.
 * @param title - Page-specific title (e.g. "My Goals"). Will render as "My Goals — Goaldigger".
 *                Pass empty string or omit to use just the site name.
 */
export function useDocumentTitle(title?: string) {
  useEffect(() => {
    const prev = document.title;
    document.title = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
    return () => {
      document.title = prev;
    };
  }, [title]);
}
